module.exports = __webpack_public_path__ + "assets/img/1-2.faf2e287.jpg";